/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CurrentUserDetailsResponseDto } from '../models';
/**
 * RestCurrentUserApi - axios parameter creator
 * @export
 */
export const RestCurrentUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCurrentUserApi - functional programming interface
 * @export
 */
export const RestCurrentUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCurrentUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentUserDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCurrentUserApi.getCurrentUserDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCurrentUserApi - factory interface
 * @export
 */
export const RestCurrentUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCurrentUserApiFp(configuration)
    return {
        /**
         * 
         * @summary Get current user details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserDetails(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUserDetailsResponseDto> {
            return localVarFp.getCurrentUserDetails(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCurrentUserApi - interface
 * @export
 * @interface RestCurrentUserApi
 */
export interface RestCurrentUserApiInterface {
    /**
     * 
     * @summary Get current user details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestCurrentUserApiInterface
     */
    getCurrentUserDetails(options?: RawAxiosRequestConfig): AxiosPromise<CurrentUserDetailsResponseDto>;

}

/**
 * RestCurrentUserApi - object-oriented interface
 * @export
 * @class RestCurrentUserApi
 * @extends {BaseAPI}
 */
export class RestCurrentUserApi extends BaseAPI implements RestCurrentUserApiInterface {
    /**
     * 
     * @summary Get current user details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestCurrentUserApi
     */
    public getCurrentUserDetails(options?: RawAxiosRequestConfig) {
        return RestCurrentUserApiFp(this.configuration).getCurrentUserDetails(options).then((request) => request(this.axios, this.basePath));
    }
}

